import { forwardRef, type HTMLAttributes } from 'react'
import { FileText, type LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

/**
 * DocIcon — квадратная плитка-иконка документа (`.doc-ic` макета): размер/радиус из токенов,
 * контурная иконка сетки 24. Декоративна (скрыта от AT), когда рядом есть текстовая подпись.
 */
export interface DocIconProps extends HTMLAttributes<HTMLSpanElement> {
  icon?: LucideIcon
  /** Доступное имя, если плитка значима без сопровождающей подписи. */
  label?: string
}

export const DocIcon = forwardRef<HTMLSpanElement, DocIconProps>(
  ({ className, icon: Glyph = FileText, label, ...props }, ref) => (
    <span
      ref={ref}
      role={label ? 'img' : undefined}
      aria-label={label}
      className={cn(
        'inline-flex size-avatar shrink-0 items-center justify-center rounded-8 bg-gray-bg text-txt-secondary',
        className,
      )}
      {...props}
    >
      <Glyph className="size-5 stroke-current" strokeWidth={1.7} aria-hidden />
    </span>
  ),
)
DocIcon.displayName = 'DocIcon'
